import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.392 7.111c.022.02.043.04.062.063l3.049 3.603a.535.535 0 0 1-.408.88H11.99v7.035c0 .21-.171.382-.382.382h-1.111a.382.382 0 0 1-.382-.382v-7.035H7.998a.535.535 0 0 1-.409-.88l3.049-3.603a.535.535 0 0 1 .754-.063Zm5.466-3.17c.211 0 .382.206.382.459v.917c0 .253-.17.458-.382.458H5.157c-.211 0-.382-.205-.382-.458V4.4c0-.253.171-.458.382-.458h11.701Z",
  "fill-rule": "evenodd",
  "data-follow-fill": "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }